import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Row,
  Col,

} from "antd";

import { recordError } from "../../../utils/logService";
import util from "../../../utils/functions/custom";
import EditProjectLead from "../projectlead/EditProjectLead";
import { Messages, Notify } from '../../../services/custom/Messages';
import { openNotification } from '@seims/shared';
import service from '../../../services/citizenscienceService';

export default function ProjectLead({ data }) {
  let msg = "";
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {

  }, [data]);

   const editProjectLead = () => {
     setShowModal(true);
  }

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleModalSubmit = async (values) => {
    try {
      let project = data.projectProfile;
      project.projectLead.firstname = values.firstname;
      project.projectLead.lastname = values.lastname;
      project.projectLead.title = values.title.key;
      project.projectLead.contactNumber = values.contactNumber;
      let projectId = data.id;
      data.titleName = values.title.value;

      const request = await service.editProject(
        project,
        projectId
      );

      if (request?.status == 200 || request?.status == 201) {
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Project lead updated");
        openNotification("Project Lead", msg, Notify.SUCCESS);
      }
      setShowModal(false);
   
    } catch (error) {
      msg = util.parseMessage(Messages.GET_FAILURE);
      openNotification("Participant", msg, Notify.ERROR);
      recordError(error);
    };
  };

  return (
    <>
      <Col xs={24}>
        <div className="public-portal-section">
          <h2> Citizen Science - {data.name} </h2>
        </div>
      </Col>
      <Col xs={24}>
        <h3 className="center-align">Project Status - <span style={{ color: data.statusColor }}>{data.status}</span> </h3>
      </Col>
      <Card
        bordered={false}
        headStyle={{ border: 0, textAlign: "center" }}
      >
        <Row>
          <Col xs={16}>
            <h3 className="h3-text">Project Lead</h3>
          </Col>
          {(data.status !== "Rejected" && data.status !== "Closed") && (
            <Col xs={8}>
              <Button className="right-align-button edit-button" type="primary" shape="round" onClick={() => editProjectLead()} >
                Edit
              </Button>
            </Col>
          )}

        </Row>
        <Row>
          <Col xs={8} sm={6} md={4}><b>Title:</b></Col>
          <Col xs={12} md={6}>{data.titleName}</Col>
        </Row>
        <Row>
          <Col xs={8} sm={6} md={4}><b>Name:</b></Col>
          <Col xs={12} md={6}>{data.projectProfile?.projectLead.firstname}</Col>
        </Row>

        <Row>
          <Col xs={8} sm={6} md={4}><b>Surname:</b></Col>
          <Col xs={6} md={6}>{data.projectProfile?.projectLead.lastname}</Col>
        </Row>
        <Row>
          <Col xs={8} sm={6} md={4}><b>Cellphone Number:</b></Col>
          <Col xs={12} md={6}>{data.projectProfile?.projectLead.contactNumber}</Col>
        </Row>
        <Row>
          <Col xs={8} sm={6} md={4}><b>Email:</b></Col>
          <Col xs={12} md={6}>{data.projectProfile?.projectLead.email}</Col>
        </Row>
      </Card>
      <Row>
        <Col xs={24}>
          <EditProjectLead
            data={data.projectProfile?.projectLead}
            visible={showModal}
            onCancel={handleCancel}
            onModalSubmit={handleModalSubmit}
          />
        </Col>
      </Row>
    </>
  )
}
